var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVehicleUnderRepair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 14.000000000000002 13",
    width: 14.000000000000002,
    height: 13,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.1102230246251565e-15, 0) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,12v-1h10v1c0,0.55 0.45,1 1,1v0c0.55,0 1,-0.45 1,-1v-6.31c0,0 -1.34,-4.03 -1.56,-4.69c-0.05,-0.16 -0.12,-0.29 -0.19,-0.4c-0.02,-0.02 -0.03,-0.04 -0.05,-0.07c-0.38,-0.52 -0.92,-0.53 -0.92,-0.53h-8.56c0,0 -0.54,0.01 -0.92,0.54c-0.02,0.02 -0.03,0.04 -0.05,0.06c-0.07,0.11 -0.14,0.24 -0.19,0.4c-0.22,0.66 -1.56,4.69 -1.56,4.69v6.31c0,0.55 0.45,1 1,1v0c0.55,0 1,-0.45 1,-1zM4,8.5c-0.55,0 -1,-0.45 -1,-1c0,-0.55 0.45,-1 1,-1c0.55,0 1,0.45 1,1c0,0.55 -0.45,1 -1,1zM10,8.5c-0.55,0 -1,-0.45 -1,-1c0,-0.55 0.45,-1 1,-1c0.55,0 1,0.45 1,1c0,0.55 -0.45,1 -1,1zM3.33,2h7.34l0.23,0.69l0.43,1.31h-8.66z",
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(255, 0, 0)"
    },
    vectorEffect: "non-scaling-stroke"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-163946483692062032",
    d: "M2,12v-1h10v1c0,0.55 0.45,1 1,1v0c0.55,0 1,-0.45 1,-1v-6.31c0,0 -1.34,-4.03 -1.56,-4.69c-0.05,-0.16 -0.12,-0.29 -0.19,-0.4c-0.02,-0.02 -0.03,-0.04 -0.05,-0.07c-0.38,-0.52 -0.92,-0.53 -0.92,-0.53h-8.56c0,0 -0.54,0.01 -0.92,0.54c-0.02,0.02 -0.03,0.04 -0.05,0.06c-0.07,0.11 -0.14,0.24 -0.19,0.4c-0.22,0.66 -1.56,4.69 -1.56,4.69v6.31c0,0.55 0.45,1 1,1v0c0.55,0 1,-0.45 1,-1zM4,8.5c-0.55,0 -1,-0.45 -1,-1c0,-0.55 0.45,-1 1,-1c0.55,0 1,0.45 1,1c0,0.55 -0.45,1 -1,1zM10,8.5c-0.55,0 -1,-0.45 -1,-1c0,-0.55 0.45,-1 1,-1c0.55,0 1,0.45 1,1c0,0.55 -0.45,1 -1,1zM3.33,2h7.34l0.23,0.69l0.43,1.31h-8.66z",
    vectorEffect: "non-scaling-stroke"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleUnderRepair);
export default __webpack_public_path__ + "static/media/VehicleUnderRepair.1a52a9483f762eab3e8d0a4a9f9b4c89.svg";
export { ForwardRef as ReactComponent };